import React from 'react';
import ReactMarkdown, { type Components } from 'react-markdown';

/**
 * Renders assistant answers as markdown inside the map assistant panel.
 *
 * react-markdown builds React elements and escapes raw HTML by default (no
 * rehype-raw here, unlike the scraped-description renderer), so LLM- or
 * DB-sourced text cannot inject markup. Links open in a new tab with a safe rel.
 */
const components: Components = {
  a: ({ node, ...props }) => (
    <a target="_blank" rel="noopener nofollow ugc" className="underline" {...props} />
  ),
  p: ({ node, ...props }) => <p className="mb-2 last:mb-0" {...props} />,
  ul: ({ node, ...props }) => <ul className="my-1 list-disc space-y-0.5 pl-5" {...props} />,
  ol: ({ node, ...props }) => <ol className="my-1 list-decimal space-y-0.5 pl-5" {...props} />,
  code: ({ node, ...props }) => (
    <code className="rounded bg-black/10 px-1 text-[0.85em] dark:bg-white/15" {...props} />
  ),
  pre: ({ node, ...props }) => (
    <pre
      className="my-1 overflow-x-auto rounded bg-black/10 p-2 text-[0.8em] dark:bg-white/10 [&>code]:bg-transparent [&>code]:p-0"
      {...props}
    />
  ),
  h1: ({ node, ...props }) => <h1 className="mb-1 mt-2 text-base font-semibold" {...props} />,
  h2: ({ node, ...props }) => <h2 className="mb-1 mt-2 text-sm font-semibold" {...props} />,
  h3: ({ node, ...props }) => <h3 className="mb-1 mt-2 text-sm font-semibold" {...props} />,
  blockquote: ({ node, ...props }) => (
    <blockquote
      className="my-1 border-l-2 border-black/20 pl-2 opacity-80 dark:border-white/20"
      {...props}
    />
  ),
};

export const MarkdownMessage: React.FC<{ content: string }> = ({ content }) => (
  <ReactMarkdown components={components}>{content}</ReactMarkdown>
);
